import { useDispatch, useSelector } from 'react-redux'
import styles from './styles/Hero.css'
import Header from 'components/typography/Header'
import PartnersPanel from '../partners/PartnersPanel'
import Link from '../misc/Link'
import classNames from 'classnames'
import Button from '../forms/Button'
import { toggleModal } from 'store/ui/actions'
import { setMode } from '../../store/login-modal/actions'
import { selectPapersMillions, selectCitationsBillions } from '../../store/home/selectors'

const HeaderContainer = () => (
  <div className={styles.heroHeaderInnerContainer}>
    <Header level={1} className={styles.heroHeader}>
      Ask a question, get an answer backed by real research
    </Header>
  </div>
)

const Illustration = () => (
  <div className={styles.illoContainer}>
    <img
      alt='hero'
      className={styles.illoBackground}
      src={`${CONFIG.assetsBaseURL}/images/illustrations/home-background-illo-v2.png`}
    />
    <div className={classNames(styles.illo)}>
      <img
        alt='assistant_ask_question'
        className={styles.illoImg}
        src={`${CONFIG.assetsBaseURL}/images/illustrations/assistant-ask-question.png`}
        width='1094'
        height='798'
      />
    </div>
  </div>
)

const Hero = ({ children }) => {
  const dispatch = useDispatch()

  const citationsBillions = useSelector(({ home }) => selectCitationsBillions(home))
  const papersMillions = useSelector(({ home }) => selectPapersMillions(home))

  const handleSignup = () => {
    dispatch(setMode('register'))
    dispatch(toggleModal('login'))
  }

  return (
    <div className={styles.heroContainer}>
      {children}
      <div className={styles.heroLayout}>
        <div className={styles.heroHeaderContainer}>
          <HeaderContainer />
          <div>
            <Button
              bold
              color='blue'
              className={styles.link}
              onClick={handleSignup}
            >
              Start your free trial
            </Button>
            <Link
              bold
              blue
              to='/assistant'
            >
              <Button
                className={classNames(styles.secondaryCtaBtn, styles.link)} bold
              >
                Try it →
              </Button>
            </Link>
          </div>
        </div>
        <Illustration />
        <div className={styles.content}>
          <div className={styles.countPanel}>
            <Header level={2} className={styles.count}>
              <strong>{`${citationsBillions}b`}</strong> citation statements extracted and analyzed
            </Header>
            <Header level={2} className={styles.count}>
              <strong>{papersMillions}m</strong> articles, book chapters, preprints, and datasets
            </Header>
            <Link className={styles.sampleLink} blue bold to='/reports/association-between-amygdala-hyperactivity-to-gVamGz'>
              See example publication report
            </Link>
          </div>
          <PartnersPanel
            header=''
            subheader='Trusted by leading Universities, Publishers, and Corporations across the world.'
            wideLayout
          />
        </div>
      </div>
    </div>
  )
}

export default Hero
